import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), 'SignalCellular0Bar');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellular0Bar.js
// module id = 6133
// module chunks = 2